module.exports = __webpack_public_path__ + "img/banner-4.10684ab4.jpg";